import { PermRole, RoleAppNav, UserRole } from '@/models/user-data.model';
import { HttpClient } from '@angular/common/http';
import { Injectable, signal } from '@angular/core';
import { Observable } from 'rxjs';
import { AccessPermission } from 'src/app/models/access-permission';
import { AppNav, NavCategory } from 'src/app/models/app-nav';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PermsService {
  private BASE_URL = environment.landmark_API_URL + '/perms';
  selectedPerm = signal<AccessPermission | null>(null);
  permissions = signal<AccessPermission[]>([]);

  constructor(private http: HttpClient) {
    this.populatePerms();
   }

//===============roles===================

  addRole(newNote: any) {
    return this.http.post(`${this.BASE_URL}/notes/`, newNote);
  }

  getRoles(): Observable<PermRole[]> {
    return this.http.get<PermRole[]>(`${this.BASE_URL}/roles/`);
  }

  updateRole(roleId: number, changes: any): Observable<PermRole> {
    return this.http.put<PermRole>(`${this.BASE_URL}/roles/${roleId}`, changes);
  }

  deleteRole(roleId: number) {
    return this.http.delete(`${this.BASE_URL}/roles/${roleId}`);
  }

//===============perm strings==============

getPerms(): Observable<AccessPermission[]> {
  return this.http.get<AccessPermission[]>(`${this.BASE_URL}/perms/`);
}

//===============app nav===================

  addNav(newNav: any): Observable<AppNav[]> {
    return this.http.post<AppNav[]>(`${this.BASE_URL}/appnav/`, newNav);
  }

  getNavs(): Observable<AppNav[]> {
    return this.http.get<AppNav[]>(`${this.BASE_URL}/appnav/`);
  }

  updateNav(navId: number, changes: Partial<AppNav>): Observable<AppNav> {
    return this.http.put<AppNav>(`${this.BASE_URL}/appnav/${navId}`, changes);
  }

  deleteNav(navId: number) {
    return this.http.delete(`${this.BASE_URL}/appnav/${navId}`);
  }

//===============app nav categories===================

  getNavCategories(): Observable<NavCategory[]> {
    return this.http.get<NavCategory[]>(`${this.BASE_URL}/navcats/`);
  }

//===============user role===================

  addUserRole(UID: number, roleId:number): Observable<UserRole> {
    const newUserRole: Partial<UserRole> = {
      UID: UID,
      PermRoleID: roleId
    }
    return this.http.post<UserRole>(`${this.BASE_URL}/userroles/`, newUserRole);
  }

  deleteUserRole(userRoleId: number) {
    return this.http.delete(`${this.BASE_URL}/userroles/${userRoleId}`);
  }

  //===============Role Nav item===================

  addNavItem(appNavId: number, permRoleID:number): Observable<RoleAppNav> {
    const newRoleAppNav: Partial<RoleAppNav> = {
      appNavId: appNavId,
        PermRoleID: permRoleID,
    }
    return this.http.post<RoleAppNav>(`${this.BASE_URL}/roleappnav/`, newRoleAppNav);
  }

  deleteNavItem(appNavId: number) {
    return this.http.delete(`${this.BASE_URL}/roleappnav/${appNavId}`);
  }

  savePerm(permData: Partial<AccessPermission>, permId?: number) {
    const body = {
      AccessPermID: permId,
      data:permData
    }
    return this.http.post<AccessPermission>(`${this.BASE_URL}/perms/`, 
      body);
  }
  populatePerms() {
    this.getPerms().subscribe(perms => {
      console.log('perms', perms);
      this.permissions.set(perms);
    });
  }
  deletePerm(permID: number) {
    return this.http.delete(`${this.BASE_URL}/perms/${permID}`);
  }

  addOrUpdatePerm(perm: AccessPermission) {
    const currentPerms = this.permissions();
    const newPerms = currentPerms.filter(p => p.AccessPermID !== perm.AccessPermID);
    newPerms.push(perm);
    this.permissions.set(newPerms);
  }
}
